module.exports = __webpack_public_path__ + "static/media/banner-content-bg.981f905a.png";